export const common = {
  nav: {
    home: 'HOME',
    services: 'SERVICES',
    about: 'ABOUT',
    contact: 'CONTACT',
    getInTouch: 'Get in Touch'
  },
  hero: {
    label: 'TECHNOLOGY PARTNER',
    headline: 'Technology & Business Services Delivered Reliably',
    subheadline: 'IT services, consulting, data processing, business mediation and marketing solutions for modern companies.',
    primaryBtn: 'Request Consultation',
    secondaryBtn: 'View Services'
  },
  strengths: {
    tech: {
      title: 'Technology Focus',
      desc: 'Advanced IT solutions and digital services'
    },
    eu: {
      title: 'EU Business Environment',
      desc: 'Operating within European standards'
    },
    reliable: {
      title: 'Reliable Service Delivery',
      desc: 'Consistent and professional execution'
    },
    fast: {
      title: 'Fast Communication',
      desc: 'Quick response and clear dialogue'
    }
  },
  services: {
    title: 'Our Services',
    subtitle: 'Comprehensive technology and business solutions',
    it: {
      title: 'IT Services',
      desc: 'Software solutions, data processing, hosting support and technical infrastructure management for your business needs.'
    },
    mediation: {
      title: 'Business Mediation',
      desc: 'Support in commercial partnerships, coordination and facilitation of business relationships across markets.'
    },
    consulting: {
      title: 'Consulting & Expert Opinions',
      desc: 'Professional analysis, evaluation and expert recommendations for strategic business decisions.'
    },
    technical: {
      title: 'Technical & Graphic Works',
      desc: 'Technical documentation, diagrams, digital materials and visual content creation.'
    },
    marketing: {
      title: 'Advertising & Marketing',
      desc: 'Marketing support, strategy development, digital assets and promotional campaigns.'
    },
    automation: {
      title: 'Process Automation',
      desc: 'Streamlining repetitive workflows through intelligent automation, reducing manual effort and increasing operational efficiency.'
    },
    learnMore: 'Learn More'
  },
  about: {
    label: 'ABOUT NEXNOVA',
    title: 'Reliability Through Structure',
    description: 'NEXNOVA SOLUTIONS supports businesses with technology and professional services. We focus on delivering structured, reliable solutions that help companies operate efficiently in the modern digital environment. Our approach combines technical expertise with clear communication and business-oriented thinking.',
    principles: {
      reliability: {
        title: 'Reliability',
        desc: 'Consistent delivery and dependable service'
      },
      communication: {
        title: 'Clear Communication',
        desc: 'Transparent and straightforward dialogue'
      },
      execution: {
        title: 'Structured Execution',
        desc: 'Organized and methodical approach'
      },
      business: {
        title: 'Business Oriented Solutions',
        desc: 'Practical and results-focused services'
      }
    }
  },
  contact: {
    title: 'Get in Touch',
    subtitle: "Let's discuss your technology needs",
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    form: {
      fullName: 'Full Name',
      emailLabel: 'Email',
      company: 'Company',
      phoneLabel: 'Phone',
      message: 'Message',
      privacy: 'I agree to the processing of my personal data',
      submit: 'Send Message',
      success: 'Message sent successfully!',
      error: 'Failed to send message. Please try again.',
      required: 'This field is required',
      invalidEmail: 'Please enter a valid email address',
      maxLength: 'Message cannot exceed 500 characters'
    }
  },
  footer: {
    tagline: 'Technology and Business Services',
    description: 'NEXNOVA SOLUTIONS provides comprehensive IT services, consulting, and business support to help companies thrive in the digital age.',
    navigation: 'Navigation',
    contactInfo: 'Contact',
    servicesTitle: 'Services',
    copyright: '© 2026 NEXNOVA SOLUTIONS S.R.O. All rights reserved.'
  },
  servicePages: {
    cta: {
      title: 'Ready to Get Started?',
      subtitle: 'Contact us today to discuss how we can help your business grow with tailored solutions and expert support.',
      btn: 'Request Consultation',
      back: 'Back to Home',
    },
    it: {
      label: 'IT SERVICES',
      title: 'IT Services',
      subtitle: 'End-to-end software solutions, data processing, hosting infrastructure and technical support — built to keep your business running at full speed.',
      features: {
        f1: { title: 'Custom Software Development', desc: 'Tailored applications and platforms designed around your specific business processes and goals.' },
        f2: { title: 'Data Processing & Management', desc: 'Structured handling, transformation and storage of business data with accuracy and reliability.' },
        f3: { title: 'Hosting & Cloud Infrastructure', desc: 'Stable, scalable hosting environments with monitoring, backups and performance optimization.' },
        f4: { title: 'Cybersecurity & Data Protection', desc: 'Security audits, access controls and data protection measures aligned with EU standards.' },
        f5: { title: 'System Integration', desc: 'Connecting your existing tools, APIs and platforms into a unified, efficient workflow.' },
        f6: { title: 'Technical Support & Maintenance', desc: 'Ongoing support, updates and troubleshooting to keep your systems stable and up to date.' },
      },
      details: {
        d1: {
          label: 'SOFTWARE SOLUTIONS',
          title: 'Custom-Built Software for Real Business Needs',
          body: 'We develop software that fits your exact requirements — from internal management tools and client portals to data pipelines and automation systems. Every solution is built with scalability and maintainability in mind, ensuring it grows alongside your business without technical debt.',
        },
        d2: {
          label: 'INFRASTRUCTURE & HOSTING',
          title: 'Reliable Infrastructure You Can Depend On',
          body: 'Our hosting and infrastructure services provide a solid foundation for your digital operations. We manage server environments, cloud deployments and backup strategies so your team can focus on business — not downtime. All environments are monitored 24/7 with rapid incident response.',
        },
      },
    },
    mediation: {
      label: 'BUSINESS MEDIATION',
      title: 'Business Mediation',
      subtitle: 'Facilitating commercial partnerships, cross-market coordination and business relationship management with professionalism and clarity.',
      features: {
        f1: { title: 'Partnership Facilitation', desc: 'Identifying and connecting compatible business partners across industries and markets.' },
        f2: { title: 'Cross-Border Coordination', desc: 'Managing communication and logistics between parties operating in different countries or legal environments.' },
        f3: { title: 'Stakeholder Management', desc: 'Coordinating interests of multiple parties to reach mutually beneficial outcomes efficiently.' },
        f4: { title: 'Contract & Agreement Support', desc: 'Assisting in the preparation and review of commercial agreements and partnership documentation.' },
        f5: { title: 'Negotiation Support', desc: 'Professional guidance and representation during commercial negotiations to protect your interests.' },
        f6: { title: 'Dispute Resolution', desc: 'Neutral mediation services to resolve commercial disputes quickly and without litigation.' },
      },
      details: {
        d1: {
          label: 'PARTNERSHIP BUILDING',
          title: 'Building Bridges Between Businesses',
          body: 'NEXNOVA SOLUTIONS acts as a trusted intermediary, helping companies establish and maintain productive commercial relationships. Whether you are entering a new market, seeking a reliable supplier or looking for a distribution partner, we provide the coordination and communication infrastructure to make it happen smoothly.',
        },
        d2: {
          label: 'CROSS-MARKET REACH',
          title: 'Expanding Your Reach Across Markets',
          body: 'Operating across European markets, we help businesses navigate the complexities of cross-border commerce. From language and cultural differences to regulatory requirements, our mediation services ensure that your business relationships are built on a solid, transparent foundation — regardless of geography.',
        },
      },
    },
    consulting: {
      label: 'CONSULTING & EXPERT OPINIONS',
      title: 'Consulting & Expert Opinions',
      subtitle: 'Strategic analysis, professional evaluations and expert recommendations to support your most important business decisions.',
      features: {
        f1: { title: 'Strategic Business Consulting', desc: 'In-depth analysis of your business model, market position and growth opportunities.' },
        f2: { title: 'Market & Competitive Analysis', desc: 'Data-driven research into market trends, competitor positioning and industry dynamics.' },
        f3: { title: 'Due Diligence & Audits', desc: 'Thorough evaluation of business processes, financials and operational risks before key decisions.' },
        f4: { title: 'Expert Reports & Opinions', desc: 'Formal written expert opinions and assessments for legal, commercial or regulatory purposes.' },
        f5: { title: 'Process Optimization', desc: 'Identifying inefficiencies and recommending structured improvements to your operations.' },
        f6: { title: 'Regulatory & Compliance Guidance', desc: 'Navigating EU regulations, compliance requirements and industry standards with confidence.' },
      },
      details: {
        d1: {
          label: 'STRATEGIC CONSULTING',
          title: 'Expert Guidance for Smarter Decisions',
          body: 'Our consulting practice combines deep industry knowledge with analytical rigor. We work closely with your leadership team to understand your challenges, evaluate your options and deliver clear, actionable recommendations. Whether you are planning an expansion, restructuring operations or entering a new market, we provide the strategic clarity you need.',
        },
        d2: {
          label: 'EXPERT OPINIONS',
          title: 'Formal Assessments You Can Rely On',
          body: 'We produce professional expert opinions and evaluation reports for a wide range of purposes — from supporting legal proceedings and regulatory submissions to informing investment decisions. Our assessments are thorough, well-documented and delivered with the precision that high-stakes situations demand.',
        },
      },
    },
    technical: {
      label: 'TECHNICAL & GRAPHIC WORKS',
      title: 'Technical & Graphic Works',
      subtitle: 'Precise technical documentation, professional diagrams and high-quality visual content — crafted to communicate your ideas clearly and effectively.',
      features: {
        f1: { title: 'Technical Documentation', desc: 'Structured and accurate technical documents, manuals and specifications tailored to your industry standards.' },
        f2: { title: 'Engineering Diagrams & Schematics', desc: 'Detailed technical drawings, flowcharts and schematics for engineering, construction and process documentation.' },
        f3: { title: 'Digital Graphic Design', desc: 'Professional visual materials including illustrations, infographics and branded digital assets.' },
        f4: { title: 'Layout & Print Design', desc: 'Clean, structured layouts for reports, presentations, brochures and print-ready materials.' },
        f5: { title: 'Print-Ready Production', desc: 'Preparation of files for professional printing with correct color profiles, bleed and resolution.' },
        f6: { title: 'Brand Visual Identity', desc: 'Consistent visual language across all materials — logos, color systems, typography and style guides.' },
      },
      details: {
        d1: {
          label: 'TECHNICAL DOCUMENTATION',
          title: 'Accurate Documentation for Complex Processes',
          body: 'We produce clear, structured technical documentation that meets professional and regulatory standards. From user manuals and installation guides to process schematics and engineering drawings, our documentation is precise, well-organized and easy to follow — reducing errors and improving operational clarity across your organization.',
        },
        d2: {
          label: 'GRAPHIC & VISUAL DESIGN',
          title: 'Visual Content That Communicates with Impact',
          body: 'Our graphic design services cover everything from brand identity and digital illustrations to print layouts and promotional materials. We combine technical precision with creative thinking to produce visuals that are not only beautiful but purposeful — ensuring your brand communicates consistently and professionally across every touchpoint.',
        },
      },
    },
    marketing: {
      label: 'ADVERTISING & MARKETING',
      title: 'Advertising & Marketing',
      subtitle: 'Strategic marketing support, digital campaigns and promotional content designed to grow your brand visibility and drive measurable business results.',
      features: {
        f1: { title: 'Marketing Strategy Development', desc: 'Building data-driven marketing plans aligned with your business goals, target audience and competitive landscape.' },
        f2: { title: 'Digital Advertising Campaigns', desc: 'Planning and execution of online advertising across search, display and social media platforms.' },
        f3: { title: 'Email Marketing', desc: 'Targeted email campaigns with compelling content, segmentation and performance tracking.' },
        f4: { title: 'Social Media Marketing', desc: 'Content strategy, scheduling and community management across key social media channels.' },
        f5: { title: 'Video & Multimedia Content', desc: 'Production of promotional videos, animations and multimedia assets for digital and broadcast use.' },
        f6: { title: 'Analytics & Performance Reporting', desc: 'Tracking campaign results, measuring ROI and delivering actionable insights to continuously improve performance.' },
      },
      details: {
        d1: {
          label: 'MARKETING STRATEGY',
          title: 'Strategy-First Marketing That Delivers Results',
          body: 'Effective marketing starts with a clear strategy. We work with you to define your target audience, identify the right channels and build a coherent plan that connects your brand with the right people at the right time. Every campaign we run is grounded in data, aligned with your business objectives and designed to generate measurable outcomes.',
        },
        d2: {
          label: 'CONTENT & CAMPAIGNS',
          title: 'Compelling Content Across Every Channel',
          body: 'From digital ads and social media posts to email sequences and promotional videos, we create content that captures attention and drives action. Our team handles the full production cycle — from concept and copywriting to design and distribution — ensuring your marketing materials are consistent, professional and effective across all platforms.',
        },
      },
    },
    automation: {
      label: 'PROCESS AUTOMATION',
      title: 'Process Automation',
      subtitle: 'Intelligent automation solutions that eliminate repetitive tasks, reduce manual effort and free your team to focus on work that truly matters.',
      features: {
        f1: { title: 'Workflow Automation', desc: 'Automating multi-step business processes to eliminate bottlenecks and reduce manual intervention.' },
        f2: { title: 'Process Mapping & Design', desc: 'Analyzing and redesigning your workflows to identify automation opportunities and optimize efficiency.' },
        f3: { title: 'Scheduled & Triggered Tasks', desc: 'Setting up automated tasks that run on schedules or in response to specific events and conditions.' },
        f4: { title: 'RPA & Intelligent Automation', desc: 'Robotic Process Automation for repetitive data entry, document handling and system interactions.' },
        f5: { title: 'Alerts & Notifications', desc: 'Automated monitoring with smart alerts that keep your team informed without manual checking.' },
        f6: { title: 'Automation Dashboards', desc: 'Real-time visibility into automated processes with performance metrics and status monitoring.' },
      },
      details: {
        d1: {
          label: 'WORKFLOW AUTOMATION',
          title: 'Eliminate Repetition. Accelerate Operations.',
          body: 'We analyze your existing workflows and identify where automation can have the greatest impact. By replacing manual, repetitive tasks with intelligent automated processes, we help your team work faster, make fewer errors and focus on higher-value activities. Our automation solutions are built to integrate seamlessly with your existing tools and systems.',
        },
        d2: {
          label: 'MONITORING & CONTROL',
          title: 'Full Visibility Over Your Automated Processes',
          body: 'Automation without oversight is a risk. We build monitoring layers into every solution — giving you real-time dashboards, automated alerts and detailed logs so you always know what is running, what has completed and what needs attention. Our systems are designed for reliability, with built-in error handling and recovery mechanisms.',
        },
      },
    },
  },
};